// extracted by mini-css-extract-plugin
export var container = "style-module--container--e2ccc";
export var fit = "style-module--fit--c8e42";
export var form = "style-module--form--71470";
export var formWrap = "style-module--form-wrap--531ad";
export var oldPrice = "style-module--old-price--330ab";
export var price = "style-module--price--6f258";
export var priceWrap = "style-module--price-wrap--aed42";
export var reg = "style-module--reg--54bb6";
export var widget = "style-module--widget--171b9";